import React from "react";
import Papa from "papaparse";
import $ from "jquery";
import "datatables.net";
import "datatables.net-se";
import "datatables.net-buttons";
import "datatables.net-buttons/js/buttons.colVis.min.js";
import "datatables.net-buttons/js/buttons.html5.min.js";
import "datatables.net-select";
import "datatables.net-editor";
import "datatables.net-colreorder";

import "datatables.net-buttons-se";
import "datatables.net-select-se";
import "datatables.net-editor-se";
import "datatables.net-colreorder-se";

import "datatables.net-se/css/dataTables.semanticui.min.css";
import "datatables.net-buttons-se/css/buttons.semanticui.min.css";
import "datatables.net-select-se/css/select.semanticui.min.css";
import "datatables.net-editor-se/css/editor.semanticui.min.css";
import "datatables.net-colreorder-se/css/colReorder.semanticui.min.css";

import "./DataTablesEditor.css";
import { getTableColumnWidth } from "../../utilities/domFunctions";
import {
  getInlineInput,
  getTdFromEvent,
  setActiveInlineInputWidth,
} from "./inlineEditing";
import {
  attachFamiliesInputOnCreate,
  emitCloseEventOnBackgroundClick,
} from "./dataTableEvents";
import { attachCustomDatatableTooltips } from "./Custom/attachCustomTooltips";
import { overrideInlineInput } from "./Custom/inlineEditOverrides";
import { applyImageLoadHandler } from "./Custom/columnAdjustment";

window.$ = window.jQuery = require("jquery");
require("semantic-ui-css/semantic");

export default class DataTablesEditor extends React.Component {
  constructor(props) {
    super(props);
    this.dataTable = null;
    this.editor = null;
    this.searchDebounce = null;
  }

  preventClicksOnNestedTables() {
    const nestedTables = document.querySelectorAll(".nested-subtable");
    nestedTables.forEach((table) => {
      // Prevent all mouse events
      ["dblclick"].forEach((eventType) => {
        table.addEventListener(
          eventType,
          function (e) {
            e.stopPropagation();
            e.preventDefault();
            return false;
          },
          true
        );
      });
    });
  }

  showExpansionDisplay = (data, type, row) => {
    if (this.props.rowHasChildren(row)) {
      return `<div class='details-control'></div>`;
    }
    return null;
  };

  componentDidMount() {
    this.$el = $(this.datatableRef);

    this.editor = new $.fn.dataTable.Editor({
      ajax: this.props.editorAjax,
      table: this.$el,
      fields: this.props.fields,
    });

    let columns = this.props.columns;

    if (this.props.rowExpansion && this.props.autoGenerateExpansionColumn) {
      columns = [
        {
          orderable: false,
          searchable: false,
          data: null,
          defaultContent: "",
          className: "no-export",
          render: this.showExpansionDisplay,
        },
        ...columns,
      ];
    }

    this.dataTable = this.$el.DataTable({
      ajax: this.props.ajax,
      columns: columns,
      ...this.props.options,
      ...this.initButtons(this.props),
    });

    let preservedScrollTop = 0;
    let preservedSelection = [];

    this.dataTable.on("preDraw", () => {
      const scrollBody = $(this.dataTable.table().container()).find(
        ".dataTables_scrollBody"
      );
      preservedScrollTop = scrollBody.scrollTop();
      preservedSelection = this.dataTable
        .rows({ selected: true })
        .indexes()
        .toArray();
    });

    this.dataTable.on("draw", () => {
      requestAnimationFrame(() => {
        const scrollBody = $(this.dataTable.table().container()).find(
          ".dataTables_scrollBody"
        );
        scrollBody.scrollTop(preservedScrollTop);
        if (preservedSelection.length > 0) {
          this.dataTable.rows(preservedSelection).select();
        }
      });
    });

    this.dataTable.on("draw", attachCustomDatatableTooltips);

    applyImageLoadHandler(this.dataTable, {
      fallbackTimeout: 5000, // Wait 5 seconds before forcing adjust
      debug: true, // Enable debug logging
    });

    if (this.props.onDraw) this.dataTable.on("draw", this.props.onDraw);

    emitCloseEventOnBackgroundClick(this.editor);

    attachFamiliesInputOnCreate(this.editor);

    this.editor.on("opened", (e, mode, action) => {
      this.editor.error(""); // clearing any lingering messages/errors on open
      $("body").addClass("dimmable"); // Add this line
    });

    this.editor.on("submitComplete", (e, res, json, action) => {
      const { message } = res;

      // Adding message as error - if not an error, form will close on success anyways
      // No error specific 'on' event seems to be in our version
      this.editor.error(message);
    });

    $(this.dataTable.table().container()).on(
      "dblclick",
      "tbody td:not(:first-child)",
      (e) => {
        const $td = getTdFromEvent(e);
        const row = this.dataTable.row($td.closest("tr"));
        if (this.props.inlineEditHandler) {
          this.props.inlineEditHandler(row.data());
        }
        const headerText = $td
          .closest("table")
          .find("th")
          .eq($td.index())
          .text();

        const colWidth = getTableColumnWidth(e.target);

        if (this.props.inlineEditSubmitAll) {
          this.editor.inline($td, { submit: "all" });
        } else {
          this.editor.inline($td, { submit: "changed" });
        }

        // Handling any custom inline functionality
        overrideInlineInput(headerText, $td, row, this.editor);

        // Getting inline input for further modifying (if needed)
        const inlineInput = getInlineInput();
        if (!inlineInput) return;

        // Modifying input width when open for improved UX
        setActiveInlineInputWidth(colWidth, inlineInput);
      }
    );

    if (this.props.columnSearch) {
      this.createColumnSearch();
    }

    if (this.props.handleContextMenu) {
      $(this.dataTable.table().body()).on(
        "contextmenu",
        "tr",
        this.props.handleContextMenu
      );
    }

    if (this.props.rowExpansion) {
      let _this = this;

      $(this.dataTable.table().body()).on(
        "click",
        "div.details-control",
        function () {
          let tr = $(this).closest("tr");
          let row = _this.dataTable.table().row(tr);

          if (row.child.isShown()) {
            // This row is already open - close it
            row.child.hide();
            tr.removeClass("shown");
          } else {
            // Open this row
            let data = _this.props.rowExpansion(row.data());

            if (data != null) {
              row.child(data).show();
              tr.addClass("shown");
            }
            _this.preventClicksOnNestedTables();
          }
        }
      );
    }
  }

  executeHeaderSearch(event, columnName) {
    this.dataTable
      .column(`${columnName}:name`)
      .search(event.target.value.trim())
      .draw();
  }

  // duplicates header and turns top one into column search fields
  createColumnSearch = () => {
    // set static table height
    $(".dataTables_scrollBody").css("height", "55vh");

    $(this.dataTable.header()[0].firstChild)
      .clone(true)
      .appendTo(this.dataTable.header()[0]);

    const visibleColumns = this.props.columns.filter(
      (col) => col.visible !== false
    );

    $(this.dataTable.header()[0].children[1].children).each((i, elem) => {
      // if row expansion column is displayed, we adjust index as it wont exist in visibleColumns
      if (this.props.rowExpansion && this.props.autoGenerateExpansionColumn)
        i -= 1;

      if (!visibleColumns[i] || !visibleColumns[i].name) return;

      const columnName = visibleColumns[i].data;
      const columnTitle = $(elem).text();

      // format the header search as desired
      $(elem).removeClass("sorting");
      $(elem).css("background", "white");
      $(elem).css("white-space", "nowrap");

      if (columnName === null) {
        $(elem).html("");
        return;
      }

      // removes sorting icon
      $(elem).addClass("without-sort-icon");

      // disables sorting on header search click
      $(elem).off("click");

      const div = document.createElement("div");

      const defaultValue = visibleColumns[i]?.search?.value;
      const showSearchInput = columnTitle !== "";

      if (showSearchInput) {
        // Create the input elements
        const input = document.createElement("input");
        input.id = `header_search_${columnName}`;
        input.className = "filter_header";
        input.type = "text";
        input.style.width = "50%";
        input.placeholder = columnTitle;
        input.value = defaultValue ? defaultValue : "";
        input.className = "header_search_input_dt";

        // Add event listeners to the input elements
        input.addEventListener("keyup", (e) => {
          clearTimeout(this.searchDebounce);
          this.searchDebounce = setTimeout(
            () => this.executeHeaderSearch(e, columnName),
            500,
            e,
            columnName
          );
        });
        div.appendChild(input);
      }

      const checkbox = document.createElement("input");
      checkbox.id = `header_checkbox_${columnName}`;
      checkbox.type = "checkbox";
      if (showSearchInput) checkbox.style.marginLeft = "3px";
      checkbox.className = "header_checkbox_input_dt";

      div.appendChild(checkbox);

      checkbox.addEventListener("click", (e) => {
        if (e.target.checked) {
          this.props.handleNullFilter(columnName, true, this.dataTable);
        } else {
          this.props.handleNullFilter(columnName, false, this.dataTable);
        }
      });

      // Append the input elements to the `elem` node
      $(elem).html(div);

      // initializing search in field if provided
      if (defaultValue) {
        this.dataTable.column(`${columnName}:name`).search(defaultValue);
      }
    });
  };

  componentWillUnmount() {
    this.dataTable.rows().deselect();
    this.dataTable.destroy(false);
  }

  initButtons = (props) => {
    let o = { buttons: [] };

    if (props.minimizeButton) {
      o.buttons.push({
        text: "Minimize",
        editor: this.editor,
        action: props.minimizeFunction,
      });
    }

    if (props.pageLengthButton) {
      o.buttons.push({
        extend: "pageLength",
        editor: this.editor,
      });
    }

    if (props.createButton) {
      if (props.customCreateButtonInit) {
        o.buttons.push(props.customCreateButtonInit(this.editor));
      } else {
        o.buttons.push({
          extend: "create",
          editor: this.editor,
        });
      }
    }

    if (props.editButton) {
      if (props.customEdit) {
        o.buttons.push({
          extend: "edit",
          editor: this.editor,
          action: props.customEdit,
        });
      } else {
        o.buttons.push({ extend: "edit", editor: this.editor });
      }
    }
    if (props.removeButton)
      o.buttons.push({ extend: "remove", editor: this.editor });
    if (props.colVis)
      o.buttons.push({
        extend: "colvis",
        text: "<span title='Show/Hide Columns'>Column Visibility</span>",
      });
    const safeStripHtml = function (data, delimiter = ",") {
      const lines = data.split("\n");

      const processedLines = lines.map((line) => {
        if (!line.trim()) return line;

        let cleanLine = line;

        cleanLine = cleanLine.replace(
          /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi,
          ""
        );
        cleanLine = cleanLine.replace(
          /<style\b[^<]*(?:(?!<\/style>)<[^<]*)*<\/style>/gi,
          ""
        );
        cleanLine = cleanLine.replace(/<!--[\s\S]*?-->/g, "");

        cleanLine = cleanLine.replace(/<[^>]*>/g, "");

        cleanLine = cleanLine.replace(/&quot;/gi, '"');
        cleanLine = cleanLine.replace(/&amp;/gi, "&");
        cleanLine = cleanLine.replace(/&lt;/gi, "<");
        cleanLine = cleanLine.replace(/&gt;/gi, ">");
        cleanLine = cleanLine.replace(/&#39;/gi, "'");
        cleanLine = cleanLine.replace(/&apos;/gi, "'");
        cleanLine = cleanLine.replace(/&nbsp;/gi, " ");

        // Modified: Only collapse whitespace that isn't the delimiter
        if (delimiter === "\t") {
          // For tab-delimited, only collapse spaces (not tabs)
          cleanLine = cleanLine.replace(/ +/g, " ");
        } else {
          // For other delimiters, collapse all whitespace as before
          cleanLine = cleanLine.replace(/\s+/g, " ");
        }

        cleanLine = cleanLine.trim();

        return cleanLine;
      });

      return processedLines.join("\n");
    };

    // Updated button configuration with safe HTML stripping
    if (props.exportButton) {
      const removeEmptyHeaderColumns = function (data, separator = ",") {
        const lines = data.split("\n");
        let headerIndex = lines.findIndex((line) => line.includes(separator));
        if (headerIndex === -1) return data;

        const beforeHeader = lines.slice(0, headerIndex);
        const dataSection = lines.slice(headerIndex).join("\n");

        const parsed = Papa.parse(dataSection, {
          delimiter: separator,
          header: false,
          skipEmptyLines: false,
          quoteChar: '"',
          escapeChar: '"',
          dynamicTyping: false,
          trimHeaders: false,
          skipLinesWithError: false,
          transform: false,
        });

        if (parsed.data.length === 0) return data;

        const headers = parsed.data[0];
        const columnsToKeep = headers
          .map((header, index) =>
            (header || "").toString().trim() !== "" ? index : -1
          )
          .filter((index) => index !== -1);

        const filteredData = parsed.data.map((row) =>
          columnsToKeep.map((index) => row[index] || "")
        );

        const result = Papa.unparse(filteredData, {
          delimiter: separator,
          quotes: true,
          quoteChar: '"',
          escapeChar: '"',
          newline: "\n",
        });

        return [...beforeHeader, result].join("\n");
      };

      o.buttons.push({
        extend: "collection",
        text: "Export",
        buttons: [
          {
            extend: "copyHtml5",
            exportOptions: {
              columns: ":visible",
              stripHtml: false,
            },
            customize: function (data) {
              const processedData = removeEmptyHeaderColumns(data, "\t");
              return safeStripHtml(processedData, "\t"); // Pass the delimiter
            },
          },
          {
            extend: "csvHtml5",
            exportOptions: {
              columns: ":visible",
              stripHtml: false,
            },
            customize: function (data) {
              const processedData = removeEmptyHeaderColumns(data, ",");
              return safeStripHtml(processedData, ","); // Pass the delimiter
            },
          },
        ],
      });
    }
    if (props.customButtons)
      return { buttons: [...o.buttons, ...props.customButtons()] };
    if (o.buttons.length > 0) return o;
    return null;
  };

  search = (value) => {
    this.dataTable.search(value).draw();
  };

  render() {
    return (
      <div>
        <table
          className={`ui celled table nowrap ${this.props.className}`}
          style={{ minWidth: "100%", ...this.props.style }}
          ref={(el) => (this.datatableRef = el)}
        />
      </div>
    );
  }
}
